<div class="container">
  <div class="title-row">
    <h3 class="klabel-huge">General Filters</h3>
    <app-button
      [text]="'Reset filters'"
      class="grey"
      (click)="resetGeneralFilters()"
    ></app-button>
  </div>
  <div class="content">
    <div class="section">
      <h4 class="section-title">Date, Time & Hours</h4>

      <div class="input-group">
        <div class="input-field">
          <div class="input-header">
            <mat-icon class="input-icon">event</mat-icon>
            <span class="input-label">Date Range</span>
          </div>
          <mat-form-field appearance="outline" class="date-range-field kinput">
            <mat-date-range-input [rangePicker]="picker">
              <input
                matStartDate
                placeholder="Start date"
                [value]="mainFilter.startDate"
                (dateChange)="updateFilter('startDate', $event)"
              />
              <input
                matEndDate
                placeholder="End date"
                [value]="mainFilter.endDate"
                (dateChange)="updateFilter('endDate', $event)"
              />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
          <p class="input-description">
            Select a date range to filter courses by their start and end dates
          </p>
        </div>

        <div class="input-field">
          <div class="input-header">
            <mat-icon class="input-icon">schedule</mat-icon>
            <span class="input-label">Hours</span>
          </div>
          <input
            type="number"
            class="kinput"
            placeholder="0.00"
            min="0"
            step="0.25"
            [(ngModel)]="mainFilter.hours"
            (change)="updateFilter('hours', $event)"
          />

          <p class="input-description">
            Filter courses by the number of hours they require
          </p>
        </div>
      </div>
    </div>

    <div class="section">
      <h4 class="section-title">Additional View Options</h4>

      <div class="checkbox-group">
        <div class="checkbox-item" *ngFor="let filter of checkboxList">
          <input
            type="checkbox"
            class="kinput"
            [checked]="mainFilter[filter.parameter]"
            (change)="updateCheckboxFilter(filter.parameter, $event)"
            [id]="filter.parameter"
          />
          <label [for]="filter.parameter" class="checkbox-label">
            {{ filter.text }}
            <mat-icon class="checkbox-icon" [matTooltip]="getHelpText(filter.parameter)" matTooltipPosition="above">help_outline</mat-icon>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
